import React from 'react';
import { useMediaQuery } from 'react-responsive';

import Text from 'common/components/Text/Text';
import { CommonHash } from 'app/types';

import styles from './SelfIntroduction.module.scss';
import AcademicExperience from './AcademicExperience';
import WorkExperience from './WorkExperience';

interface CompProps {
  answers: CommonHash;
  setAnswer: (h: CommonHash) => void;
  // setSaveForm: (b: boolean) => void;
}

const SelfIntroduction = ({ answers, setAnswer }: CompProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const setInputOption = (key: string, value: any) => {
    setAnswer((a: any) => ({
      ...a,
      user: {
        ...a.user,
        [key]: value,
      },
    }));
  };

  return (
    <div className={styles.stepContainer}>
      <Text size={24} weight={600} color="primary" inlineStyle={{ marginBottom: '40px' }}>
        Self introduction
      </Text>
      <div className={styles.inputsContainter}>
        <div className={`${styles.inputGroup} ${styles.inputLessMargin}`}>
          <Text
            size={16}
            weight={isMobile ? 500 : 600}
            inlineStyle={{ marginBottom: '12px' }}
            color="primary"
          >
            What is your name
          </Text>
          <input
            className="form-control"
            type="text"
            onChange={(e) => setInputOption('name', e.target.value)}
            value={answers.user.name ? answers.user.name : ''}
          />
        </div>
      </div>
      <AcademicExperience answers={answers} setAnswer={setAnswer} />
      <WorkExperience answers={answers} setAnswer={setAnswer} />
    </div>
  );
};

export default SelfIntroduction;
